import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=616df4be&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=ts"
export * from "./notifications.vue?vue&type=script&lang=ts"
import style0 from "./notifications.vue?vue&type=style&index=0&id=616df4be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616df4be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616df4be')) {
      api.createRecord('616df4be', component.options)
    } else {
      api.reload('616df4be', component.options)
    }
    module.hot.accept("./notifications.vue?vue&type=template&id=616df4be&scoped=true", function () {
      api.rerender('616df4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/notifications.vue"
export default component.exports